import { action, ActionType } from 'typesafe-actions';

import types from './actionTypes';

export const setCardDeleted = (payload: string) => action(types.SET_CARD_DELETED, payload);

export const setForterToken = (payload: string) => action(types.SET_FORTER_TOKEN, payload);

export type PaymentActions = ActionType<typeof setCardDeleted | typeof setForterToken>;
